// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.com-label {
  border-radius: 4px;
  padding: 2px 6px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  height: 22px;
  text-align: center;
}
.com-label__type1 {
  background: #505054;
  color: #0f0d0d;
}
.com-label__type3 {
  background: #f2f2f2;
  font-family: "Spoqa Han Sans Neo";
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  align-items: center;
  color: #505054;
}

.label-special-notes {
  padding: 2px 6px;
  border-radius: 4px;
  background: #E47C77;
  width: 57px;
  height: 22px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  align-items: center;
  color: #FFFFFF;
}

.label-instructions {
  padding: 2px 6px;
  border-radius: 4px;
  background: #49AE9E;
  width: 57px;
  height: 22px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  align-items: center;
  color: #FFFFFF;
}

.label-circular {
  height: 25px;
  width: 25px;
  text-align: center;
  border-radius: 50%;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  padding: 3px 8px 3px 8px;
  background: #505054;
  color: #ffffff;
}

.label-type4 {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  background: #f3f5f4;
  border-radius: 50px;
  padding: 5px 5px 5px 10px;
  display: flex;
  align-content: center;
  height: 28px;
  width: 148px;
}
.label-type4__close {
  margin-left: auto;
  padding-left: 10px;
  cursor: pointer;
}

.num {
  height: 20px;
  width: 20px;
  text-align: center;
  border-radius: 50%;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}

.label-color__color1 {
  background: #505054;
}
.label-color__color2 {
  background: #c1c1c1;
}
.label-color__custom {
  background: var(--bg);
  color: var(--color);
  width: 68px;
}`, "",{"version":3,"sources":["webpack://./src/common/label/label.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AACJ;AACI;EACI,mBAAA;EACA,cAAA;AACR;AAEI;EACI,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAAR;;AAIA;EACQ,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAFR;;AAKA;EACQ,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAHR;;AAMA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,mBAAA;EACA,cAAA;AAHJ;;AAMA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;EAEA,YAAA;EACA,YAAA;AALJ;AAOI;EACI,iBAAA;EACA,kBAAA;EACA,eAAA;AALR;;AASA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAPJ;;AAWI;EACI,mBAAA;AARR;AAWI;EACI,mBAAA;AATR;AAYI;EACI,qBAAA;EACA,mBAAA;EACA,WAAA;AAVR","sourcesContent":[".com-label {\n    border-radius: 4px;\n    padding: 2px 6px;\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 18px;\n    height: 22px;\n    text-align: center;\n\n    &__type1 {\n        background: #505054;\n        color: #0f0d0d;\n    }\n\n    &__type3 {\n        background: #f2f2f2;\n        font-family: 'Spoqa Han Sans Neo';\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        align-items: center;\n        color: #505054;\n    }\n}\n\n.label-special-notes {\n        padding: 2px 6px;\n        border-radius: 4px;\n        background: #E47C77;\n        width: 57px;\n        height: 22px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 12px;\n        line-height: 18px;\n        align-items: center;\n        color: #FFFFFF;\n}\n\n.label-instructions {\n        padding: 2px 6px;\n        border-radius: 4px;\n        background: #49AE9E;\n        width: 57px;\n        height: 22px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 12px;\n        line-height: 18px;\n        align-items: center;\n        color: #FFFFFF;\n}\n\n.label-circular {\n    height: 25px;\n    width: 25px;\n    text-align: center;\n    border-radius: 50%;\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    padding: 3px 8px 3px 8px;\n    background: #505054;\n    color: #ffffff;\n}\n\n.label-type4 {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #333333;\n\n    background: #f3f5f4;\n    border-radius: 50px;\n    padding: 5px 5px 5px 10px;\n    display: flex;\n    align-content: center;\n\n    height: 28px;\n    width: 148px;\n\n    &__close {\n        margin-left: auto;\n        padding-left: 10px;\n        cursor: pointer;\n    }\n}\n\n.num {\n    height: 20px;\n    width: 20px;\n    text-align: center;\n    border-radius: 50%;\n\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.label-color {\n    &__color1 {\n        background: #505054;\n    }\n\n    &__color2 {\n        background: #c1c1c1;\n    }\n\n    &__custom {\n        background: var(--bg);\n        color: var(--color);\n        width: 68px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
